<div class="card-body">
    <div id="apex-bar-with-negative-values"></div>
</div>